import React from "react";
import type { UserWithRole } from "api/auth/Auth.typed";

export type UserListRoleFilterKey = string;
export type UserListAccountFilterKey = "all" | "with_account" | "without_account";

function userHasLogin(u: UserWithRole): boolean {
  return u.user.can_login !== false;
}

export function useUserListRoleFilter(users: UserWithRole[] | undefined) {
  const [roleFilterKey, setRoleFilterKey] = React.useState<UserListRoleFilterKey>("all");
  const [accountFilterKey, setAccountFilterKey] = React.useState<UserListAccountFilterKey>("all");

  const filteredUsers = React.useMemo(() => {
    if (!users?.length) {
      return users ?? [];
    }

    let list = users;

    if (accountFilterKey === "with_account") {
      list = list.filter((u) => userHasLogin(u));
    } else if (accountFilterKey === "without_account") {
      list = list.filter((u) => !userHasLogin(u));
    }

    if (roleFilterKey === "all") {
      return list;
    }

    if (roleFilterKey === "none") {
      return list.filter((u) => u.role == null || u.role.id == null || Number(u.role.id) === 0);
    }

    const id = Number(roleFilterKey);

    if (!Number.isFinite(id)) {
      return list;
    }

    return list.filter((u) => Number(u.role?.id) === id);
  }, [users, roleFilterKey, accountFilterKey]);

  return {
    roleFilterKey,
    setRoleFilterKey,
    accountFilterKey,
    setAccountFilterKey,
    filteredUsers,
  };
}
